import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

interface IExpandButtonProps {
  expanded: boolean;
  isAlternative?: boolean;
}

export const ExpandButton = styled.button<IExpandButtonProps>(
  props => css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    min-height: 100%;
    transition: background-color ${layout.animations.buttonTransition};
    background-color: transparent;
    padding: ${layout.measurements.spacing025};

    ${media.smallOnly`
      padding: ${layout.measurements.spacing050};
    `}

    ${props.expanded
      ? css`
          border-radius: 8px 0 0 0;
        `
      : css`
          border-radius: 8px 0 0 8px;
        `}



    &:hover {
      background-color: #f7f7f7;
    }

    &.focus-visible {
      outline: ${props.theme.text.linkExternalHover} dotted 1px;
      outline: -webkit-focus-ring-color auto 1px;
    }
  `
);
